import React from 'react';
import { useTranslation } from 'react-i18next';

const STYLES = {
  excellent: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30',
  healthy: 'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border-emerald-500/30',
  watch: 'bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border-yellow-500/30',
  at_risk: 'bg-orange-500/10 text-orange-600 dark:text-orange-400 border-orange-500/30',
  critical: 'bg-red-500/10 text-red-600 dark:text-red-400 border-red-500/30',
  insufficient: 'bg-slate-500/10 text-slate-500 dark:text-slate-400 border-slate-500/30',
};

const DOT = {
  excellent: 'bg-emerald-500',
  healthy: 'bg-emerald-500',
  watch: 'bg-yellow-500',
  at_risk: 'bg-orange-500',
  critical: 'bg-red-500',
  insufficient: 'bg-slate-400',
};

/**
 * Renders the deterministic per-property Health Status from the backend.
 * Never recomputes; expects the payload {band, score, ...} shape.
 */
export function PropertyHealthBadge({ status, size = 'md', showScore = false, testId }) {
  const { t } = useTranslation();
  const band = status?.band || 'insufficient';
  const cls = STYLES[band] || STYLES.insufficient;
  const label = t(`propertyHealth.${band}`);
  const padding = size === 'sm' ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-xs';
  return (
    <span
      data-testid={testId || `health-badge-${band}`}
      className={`inline-flex items-center gap-1.5 rounded-full border font-bold uppercase tracking-wider ${padding} ${cls}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${DOT[band]}`} />
      {label}
      {showScore && typeof status?.score === 'number' && (
        <span className="opacity-75 font-mono">{status.score}</span>
      )}
    </span>
  );
}
